import { render, staticRenderFns } from "./PetMedicalNote.vue?vue&type=template&id=73f4b8c3"
import script from "./PetMedicalNote.vue?vue&type=script&lang=js"
export * from "./PetMedicalNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports